<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-equalizer`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 38a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h10zm16 0a1 1 0 011 1v2a1 1 0 01-1 1H19a1 1 0 01-1-1v-2a1 1 0 011-1h10zm16 0a1 1 0 011 1v2a1 1 0 01-1 1H35a1 1 0 01-1-1v-2a1 1 0 011-1h10zM13 28a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h10zm16 0a1 1 0 011 1v2a1 1 0 01-1 1H19a1 1 0 01-1-1v-2a1 1 0 011-1h10zm16 0a1 1 0 011 1v2a1 1 0 01-1 1H35a1 1 0 01-1-1v-2a1 1 0 011-1h10zM13 18a1 1 0 011 1v2a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 011-1h10zm32 0a1 1 0 011 1v2a1 1 0 01-1 1H35a1 1 0 01-1-1v-2a1 1 0 011-1h10zm0-10a1 1 0 011 1v2a1 1 0 01-1 1H35a1 1 0 01-1-1V9a1 1 0 011-1h10z"/></svg>
</template>
<script>

export default {
  name: 'IconEqualizer',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
